module.exports = __webpack_public_path__ + "img/5D5E5A_A1A29B_2A2927_8B948C-256px.8cd7f245.png";